import React, { Component } from 'react';
import { render } from 'react-dom';
import { connect } from 'react-redux'
import { v4 } from 'uuid'
import Topbar from '../Topbar/';

import Button from '@material-ui/core/Button';

import { sendMessage } from '../MessagingScreen/actions'


import { closeRtcTracks } from './rtcUtils'

import { initInteractConfig } from './flyerInteractConfig'

import './jitsuFlyer.css'

var constraints = window.constraints = {
  audio: false,
  video: true
};


class JitsuFlyerView extends Component {
  constructor() {
    super();
    this.state = {

    }
  }

  componentDidMount() {

    initInteractConfig()

    var {videoSrc} = this.props;
    if (videoSrc) {

      var {videoElement} = this.mainJitsuFlyerViewElement()

      videoElement.srcObject = videoSrc;
      videoElement.volume = 0;

      videoElement.play();

    }

  }

  render() {

    return (
      <div style={ { zIndex: "2" } } style={ { display: 'inline-block', position: 'absolute', top: 0, left: 0, backgroundColor: "transparent" } } className=" h-100 w-100  flyer-container">
        <div className="resize-drag">
          <video style={ { zIndex: "1" } } className="h-100 w-100" id="jitsu-flyer-video">
            Video stream not available.
          </video>
        </div>
      </div>
      );
  }

  mainJitsuFlyerViewElement = () => {

    const videoElement = document.getElementById("jitsu-flyer-video");

    return {
      videoElement,
      rect: videoElement.getBoundingClientRect()
    }

  }

}

const mapStateToProps = (state, ownProps) => ({
  user: state.user,
  messaginScreen: state.messaginScreen

})

export default connect(mapStateToProps, {
  sendMessage
})(JitsuFlyerView)


// WEBPACK FOOTER //
// ./src/Components/JitsuFlyerView/index.js